// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3i7xF","filesListContainer":"PosDisputesFiles_filesListContainer__2Sd5x","filesButton":"PosDisputesFiles_filesButton__3fSWy"};